import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { SummaryRow } from "@shared/types/summary";

export const REFRESH_INTERVAL_MS = 5000;

export function useSummary() {
  return useQuery({
    queryKey: ["wallboard", "summary"],
    queryFn: () => apiGet<SummaryRow[]>("/api/wallboard/summary"),
    refetchInterval: REFRESH_INTERVAL_MS,
  });
}
